export default __webpack_public_path__ + "static/media/log-out.397dc849.svg";